import React, { useEffect, useState } from "react";
import "../../App.css";
import heroBg from "../../assets/hero-bg.jpg";
import {
  ArrowRightIcon,
  InformationCircleIcon,
} from "@heroicons/react/24/outline";
import Navbar from "../navbar/Navbar";
import Product from "../product/Products";
import Footer from "../footer/Footer";
import useScrollToTop from "../customHooks/useScrollToTop";
import Button from "../button/Button";
import { closeModal, openModal } from "../modalComponent/modalSlice";
import ModalComponent from "../modalComponent/ModalComponent";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import CustomCarousel from "../caraousel/CustomCarousel";
import CookiesComponent from "../cookies/CookiesComponent";
import { openCookies } from "../cookies/cookieSlice";
import Cookies from "js-cookie";
import SEO from "../../components/SEO";
import HbbHome from "../hbb/HbbHome";

export default function HbbDevices() {
  useScrollToTop();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const modalInitState = useSelector((state) => state.modal);
  const customerVerified = localStorage.getItem("customerVerified");
  localStorage.removeItem("orderConfirmation");
  const { referralCode } = useParams();

  const [activeTab, setActiveTab] = useState("SIMO");

  useEffect(() => {
    if (referralCode) {
      localStorage.setItem(
        "sessionReferralCode",
        referralCode && referralCode !== "null" && referralCode !== "undefined" ? referralCode : ""
      );
      navigate("/", { replace: true });
    }
  }, [referralCode, navigate]);

  useEffect(() => {
    if (customerVerified == 1) {
      dispatch(openModal("customerVerified"));
      localStorage.removeItem("customerVerified");
    }

    const cookiesPreferences = Cookies.get("cookiesPreferences") && 
      !(Object.keys(JSON.parse(Cookies.get("cookiesPreferences"))).length === 0 && 
        JSON.parse(Cookies.get("cookiesPreferences")).constructor === Object) 
      ? JSON.parse(Cookies.get("cookiesPreferences")) 
      : undefined;
    if (!cookiesPreferences) {
      dispatch(openCookies());
    }
  }, [dispatch]);

  useEffect(() => {
    const emailSendSuccess = localStorage.getItem("emailSendSuccess");
    if (emailSendSuccess === "1") {
      dispatch(openModal("emailSendPopup"));
      localStorage.setItem("emailSendSuccess", "0");
    }
  }, [dispatch]);

  useEffect(() => {
    const welcomePopup = localStorage.getItem("welcomePopup");
    if (welcomePopup === "1") {
      dispatch(openModal("welcomePopup"));
      localStorage.setItem("welcomePopup", "0");
    }
  }, [dispatch]);

  useEffect(() => {
    localStorage.removeItem("creditVettingStatus");
    localStorage.removeItem("tempDetailsForCreditVetting");
  }, []);

  return (
    <>
    <Navbar />
      <Product/>
      {modalInitState.contentId === "customerVerified" && (
        <ModalComponent
          size="md"
          type="success"
          position="center"
          description=""
          bottomLine={true}
          title="Verification Successful"
        >
          <div className="flex flex-col">
            <p>Customer Verification Successful.</p>
            <Button
              handleClick={() => dispatch(closeModal())}
              title="Okay"
              type="button"
              style="rounded mx-auto w-1/2 text-sm px-4 lg:px-5 py-2 lg:py-2.5 cta-one rounded text-sm px-4 lg:px-5 py-2 lg:py-2.5 mt-4 mx-auto font-semibold px-3 py-1.5 text-center"
            />
          </div>
        </ModalComponent>
      )}
      {modalInitState.contentId === "emailSendPopup" && (
        <ModalComponent
          size="md"
          type="success"
          position="center"
          title="Email Send"
          description=""
          bottomLine={true}
        >
          <div className="w-100 d-flex flex-column justify-content-center align-items-center mt-3">
            <h3 className="mb-3 text-center">
              Verification email has been sent to your registered email ID.
            </h3>
            <Button
              handleClick={() => dispatch(closeModal("emailSendPopup"))}
              title="Okay"
              type="button"
              style="cta-two w-full rounded text-sm px-4 lg:px-5 py-2 lg:py-2.5 mx-auto mt-2 bg-transparent hover:text-white focus:ring-4 focus:outline-none font-semibold px-3 py-1.5 text-center"
            />
          </div>
        </ModalComponent>
      )}
      {modalInitState.contentId === "welcomePopup" && (
        <ModalComponent
          size="md"
          type="success"
          position="center"
          title="Welcome to the Dealer Portal!"
          description=""
          bottomLine={true}
        >
          <div className="w-100 d-flex flex-column justify-content-center align-items-center mt-3">
            <h3 className="mb-3 text-center">
              Thank you for joining us. As a new dealer, you now have access to
              the Dashboard and can start selling contract SIMs to your
              customers. To get started, explore the onboarding guide and
              familiarise yourself with the application's features.
              <br />
              <br />
              If you have any questions or need assistance, we’re here to help!
              <br />
              <br />
              <b>Enjoy your journey with us!</b>
            </h3>
            <Button
              handleClick={() => dispatch(closeModal("welcomePopup"))}
              title="Okay"
              type="button"
              style="cta-two w-full rounded text-sm px-4 lg:px-5 py-2 lg:py-2.5 mx-auto mt-2 bg-transparent hover:text-white focus:ring-4 focus:outline-none font-semibold px-3 py-1.5 text-center"
            />
          </div>
        </ModalComponent>
      )}
      <CookiesComponent />
      <Footer />
    </>
  );
}